export default __webpack_public_path__ + "images/axion-high-flag.svg";